import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";

import Button from "components/Button/Button";

import WidgetContainer from "components/WidgetContainer/WidgetContainer";
import SecurePayMerchantLogos from "images/bs-secure-pay-merchant-users-logos.png";

import "./SecurePayOverviewWidget.css";
const SecurePayOverviewWidget = () => {
    const data = useStaticQuery(graphql`
        query BsOnlineQuery {
            mobileImage: file(relativePath: { eq: "bs-online-mobile-1x.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(relativePath: { eq: "bs-online-web-1x.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    return (
        <WidgetContainer stylesClass="secure-pay">
            <div id="secure-pay"></div>
            <div className="secure-pay__container">
                <div className="secure-pay__container__img">
                    <Img
                        fluid={data.desktopImage.childImageSharp.fluid}
                        alt="Easy Online Payments with PhonePe"
                        imgStyle={{ objectFit: "cover" }}
                    />
                </div>
                <div className="secure-pay__container__content">
                    <h2>Enable fast, simple &amp; secure online payments</h2>
                    <p className="secure-pay__container__content__text">
                        Let your customers shop, order &amp; pay hassle-free.
                        PhonePe provides secure UPI, card and wallet payment
                        options which can easily be integrated on your app or
                        website.
                    </p>
                    <div className="secure-pay__container__content__banner">
                        <Img
                            fluid={data.mobileImage.childImageSharp.fluid}
                            alt="Easy Online Payments with PhonePe"
                            imgStyle={{ objectFit: "cover" }}
                        />
                    </div>
                    <div className="secure-pay__container__content__btn-container">
                        <Button
                            btnText="Accept online payments"
                            pagePath="/business-solutions/online-merchant/"
                            btnStyle="btnStyle"
                        />
                    </div>
                    <div className="secure-pay__container__content__merchant_logo">
                        <p>Popular Merchants</p>
                        <img
                            src={SecurePayMerchantLogos}
                            alt="list of merchant logo of phonepe"
                        />
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default SecurePayOverviewWidget;
